import { get, post, put } from '../../utils/requests/fetcher';

// biome-ignore lint/suspicious/useAwait: <explanation>
export const fetchGet = async <T>(
  url: string,
  headers: Record<string, string>,
): Promise<T> => {
  return get<T>({
    url,
    headers,
  });
};

// biome-ignore lint/suspicious/useAwait: <explanation>
export const fetchPost = async <T>(
  url: string,
  body: Record<string, unknown>,
  headers: Record<string, string>,
): Promise<T> => {
  return post<T>({
    url,
    body,
    headers,
  });
};

// biome-ignore lint/suspicious/useAwait: <explanation>
export const fetchPut = async <T>(
  url: string,
  body: Record<string, unknown>,
  headers: Record<string, string>,
): Promise<T> => {
  return put<T>({
    url,
    body,
    headers,
  });
};
